import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { TextBody, get, Box, MuiTheme } from '@ally/metronome-ui'

type WithThemeType = (props: { theme: MuiTheme }) => string

const StyledTextBodyColor = styled(TextBody)<{ color: WithThemeType }>`
  color: ${({ color }): WithThemeType => color};
`

const StyledDd = styled.span`
  width: 100%;
  margin-inline-start: 0;

  ${get.media.up('lg')} {
    width: 50%;
  }

  ${get.media.up('xl')} {
    margin-inline-start: 10px;
  }
`

const StyledDt = styled.span`
  width: 100%;
  ${get.media.up('lg')} {
    width: 50%;
  }
`

export const Dd = ({
  size = 'sm',
  color = 'slate-5',
  children,
}: {
  size?: any
  color?: any
  children?: any
}): ReactElement => (
  <StyledDd>
    <StyledTextBodyColor tag="div" size={size} color={get.colors(color)}>
      {children}
    </StyledTextBodyColor>
  </StyledDd>
)

/* istanbul ignore next */
export const Dt = ({
  size = 'sm',
  color = 'slate-5',
  children,
}: {
  children?: any
  size?: any
  color?: any
}): ReactElement => (
  <StyledDt>
    <StyledTextBodyColor tag="div" weight="bold" size={size} color={color}>
      {children}
    </StyledTextBodyColor>
  </StyledDt>
)

export const StyledDejargTrigger = styled.span`
  text-decoration: underline dotted black 1px;
  -webkit-text-decoration: underline dotted black;
  text-underline-offset: 10%;
  &:hover {
    cursor: help;
  }
  @media print {
    text-decoration: none;
  }
`
export const AcctDetailsItem = styled(Box)`
  display: flex;
  flex-direction: column;
  ${get.media.down('sm')} {
    flex-flow: row wrap;
  }

  padding-bottom: ${get.space('sm')};
  padding-right: ${get.space('md')};
  width: 100%;
  ${get.media.up('lg')} {
    width: 50%;
  }
  ${get.media.up('xl')} {
    width: calc(100% / 3);
    flex-direction: row;
  }
  @media print {
    width: 50%;
    flex-direction: row;
  }
`

export const StyledHRWrapper = styled(Box)`
  padding-left: ${get.space('xl')};
  padding-right: ${get.space('xl')};
`

export const StyledHR = styled.hr.attrs({ 'aria-hidden': true })`
  background-color: ${get.colors('slate-2')};
  border: none;
  height: 1px;
`

export const LightDejargBody = styled(TextBody)`
  color: ${get.colors('gray-400')};
  text-align: left;
`
